import $ from 'jquery';
import 'bootstrap';

export const configureUiElements = () => {
    $(document).ready(() => {
        $('body').tooltip({ selector: '[data-toggle=tooltip]' });
    });
};
